import styled from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

export const CartItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;
  margin-top: 50%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;

  > span {
    font-size: 1.5rem;
    font-weight: 500;
    margin-left: 10px;
  }
`;
export const Body = styled.div`
  display: flex;
  flex-direction: row;
  padding: 30px 0px 10px 0px;
`;

export const ProductDetails = styled.div`
  margin-left: 20px;
  margin-top: 10px;
  > div:nth-child(1) {
    font-weight: 500rem;
    font-size: 1.1rem;
  }
  > div:nth-child(2) {
    font-weight: 400;
    color: ${DEFAULT_COLORS.grey63};
    margin-top: 5px;
  }
`;
export const Footer = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const Thumbnail = styled.div`
  position: relative;
  width: 145px;
  height: 125px;
  margin: 10px 10px 10px 10px;
  cursor: pointer;
`;
